import coverSrc from 'assets/img/generic/4.jpg';
import ProfileBanner from 'components/pages/user/ProfileBanner';
import { useAuth } from 'context/AuthContext';
import { getUserPreferences, getUserProfileData } from 'helpers/userProfile';
import React from 'react';
import { Badge, Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Banner = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();
  const {
    initials,
    displayName,
    email,
    companyName,
    profileName,
    username,
    membershipStatus,
    permissions
  } = getUserProfileData(userData);
  const preferences = getUserPreferences(userData?.userId);

  const statusLabel =
    typeof membershipStatus === 'boolean'
      ? membershipStatus
        ? t('USER_PROFILE.STATUS.ACTIVE')
        : t('USER_PROFILE.STATUS.INACTIVE')
      : membershipStatus || t('USER_PROFILE.CURRENT_ACCOUNT');

  return (
    <ProfileBanner>
      <ProfileBanner.Header avatarName={initials} coverSrc={coverSrc} />
      <ProfileBanner.Body>
        <Row className="g-3 align-items-start">
          <Col lg={8}>
            <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
              <h4 className="mb-0">{displayName}</h4>
              <Badge bg="soft-success" className="text-success">
                {statusLabel}
              </Badge>
            </div>
            <h5 className="fs-0 fw-normal text-700 mb-2">
              {[profileName, companyName].filter(Boolean).join(' at ') ||
                t('USER_PROFILE.GESTODO_ACCOUNT')}
            </h5>
            <p className="text-500 mb-1">
              {preferences.heading || email || username || t('USER_PROFILE.NO_CONTACT_INFORMATION')}
            </p>
            {preferences.intro ? (
              <p className="text-700 mb-3">{preferences.intro}</p>
            ) : (
              <div className="mb-3" />
            )}
            <div className="d-flex flex-wrap gap-2">
              <Button as={Link} to="/user/settings" variant="falcon-primary" size="sm">
                {t('USER_PROFILE.ACTIONS.EDIT_PROFILE')}
              </Button>
              <Button as={Link} to="/users" variant="falcon-default" size="sm">
                {t('USER_PROFILE.ACTIONS.MANAGE_ACCESS')}
              </Button>
            </div>
          </Col>
          <Col lg={4}>
            <div className="border rounded-3 p-3 bg-light dark__bg-1100 h-100">
              <div className="fs--2 text-600 text-uppercase fw-semi-bold mb-2">
                {t('USER_PROFILE.ACCOUNT_SUMMARY')}
              </div>
              <div className="mb-2">
                <div className="fs--2 text-500">{t('USER_PROFILE.FIELDS.USERNAME')}</div>
                <div className="text-900">{username || t('USER_PROFILE.NOT_AVAILABLE')}</div>
              </div>
              <div className="mb-2">
                <div className="fs--2 text-500">{t('USER_PROFILE.FIELDS.COMPANY')}</div>
                <div className="text-900">{companyName || t('USER_PROFILE.NOT_ASSIGNED')}</div>
              </div>
              <div>
                <div className="fs--2 text-500">{t('USER_PROFILE.PERMISSIONS')}</div>
                <div className="text-900">{permissions.length}</div>
              </div>
            </div>
          </Col>
        </Row>
      </ProfileBanner.Body>
    </ProfileBanner>
  );
};

export default Banner;
